export default __webpack_public_path__ + "static/O0044-46b4104228d833b3147a62eecfacc3f2.png";